export enum Messages {
  dataUpdated = 'has been successfully updated',
  dataCreated = 'has been successfully created',
  dataDeleted = 'has been successfully deleted',
  datApproved = 'has been successfully approved',
  someWrong = 'Something went wrong',
  noContent = 'No content',
  notFound = 'Data was not found',
  accessDenied = 'Access denied',
}
